import React from "react";
import { CircleDollarSign } from "lucide-react";
import PageHeader from "../../../components/common/PageHeader";
import { useAuth } from "../../../app/providers/AuthProvider";
import ScopedPricingEditor from "../shared/ScopedPricingEditor";

function getCurrentUserId(user) {
  return (
    user?.id ||
    user?.userId ||
    user?.Id ||
    user?.UserId ||
    null
  );
}

export default function PartnerPricingPage() {
  const { user, userName } = useAuth();
  const actorUserId = getCurrentUserId(user);
  const scopeLabel = userName ? `${userName} Partner Pricing` : "My Partner Pricing";

  return (
    <div className="min-h-screen bg-[#f3f4f6] py-6">
      <section className="px-4">
        <div className="mx-auto max-w-[1240px] space-y-6">
          <div className="px-4 pt-4 pb-1">
            <PageHeader
              icon={CircleDollarSign}
              title="Partner Pricing Rules"
              subtitle="Configure your partner-level pricing rules from the base price you inherit upstream."
            />
          </div>

          <div className="px-4">
            <ScopedPricingEditor
              scopeLevel="Partner"
              scopeEntityId={actorUserId}
              scopeLabel={scopeLabel}
              description="Adjust your inherited base price to define the default pricing you want to apply across your managed business hierarchy."
              readMode="actor"
              displayVariant="base"
              emptyStateTitle="Partner account context is not available."
              emptyStateBody="Refresh the session and try again after your partner account context finishes loading."
            />
          </div>
        </div>
      </section>
    </div>
  );
}
